export function filterOnlyTopLeagues(leagues, regions) {
    return leagues.filter((l) => l.isTopLeague || regions.includes(l.regionId || "-1"));
}
//# sourceMappingURL=filterOnlyTopLeagues.js.map